var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {},
    [
      _c(
        "el-row",
        { staticClass: "form-row", attrs: { gutter: 20 } },
        [
          _c("ShippingEligibilityInfo", {
            ref: "eligibility",
            attrs: { title: "Expedited shipping not available for:" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "form-row", attrs: { gutter: 20 } },
        [
          _c("el-col", { attrs: { span: 12 } }, [
            _c(
              "div",
              { staticClass: "grid-content bg-purple" },
              [
                _c("label", [_vm._v("Kustomer URL")]),
                _vm._v(" "),
                _c("el-input", {
                  attrs: {
                    placeholder: "https://ring.kustomer.com/chat/id",
                    name: "kustomer_url",
                  },
                  model: {
                    value: _vm.request_misc.zendesk_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.request_misc, "zendesk_id", $$v)
                    },
                    expression: "request_misc.zendesk_id",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "form-row", attrs: { gutter: 20 } },
        [
          _c("el-col", { attrs: { span: 12 } }, [
            _c(
              "div",
              { staticClass: "grid-content bg-purple" },
              [
                _c("label", [_vm._v("Order Number")]),
                _vm._v(" "),
                _c("el-input", {
                  attrs: {
                    disabled: _vm.orderNotRequired,
                    placeholder: "Order number",
                    name: "order_number",
                  },
                  model: {
                    value: _vm.request_misc.order_number,
                    callback: function ($$v) {
                      _vm.$set(_vm.request_misc, "order_number", $$v)
                    },
                    expression: "request_misc.order_number",
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          !_vm.isRefundRequest
            ? _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-row",
                    { attrs: { span: 20 } },
                    [
                      _c(
                        "el-col",
                        {
                          directives: [
                            {
                              name: "acl",
                              rawName: "v-acl.show",
                              value: {
                                permission: "select-expedited",
                                on: "CustomerRequest",
                              },
                              expression:
                                "{ permission: 'select-expedited', on: 'CustomerRequest' }",
                              modifiers: { show: true },
                            },
                          ],
                          attrs: { span: 8 },
                        },
                        [
                          _c("label", [_vm._v("Expedited")]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "el-input",
                              staticStyle: { padding: "7px 0px" },
                            },
                            [
                              _vm.expeditedNotAvailable
                                ? _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        content: _vm.expeditedNotAvailableMsg,
                                        placement: "top",
                                        effect: "light",
                                      },
                                    },
                                    [
                                      _c("el-switch", {
                                        attrs: {
                                          disabled: _vm.expeditedNotAvailable,
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _c("el-switch", {
                                    model: {
                                      value: _vm.request_misc.expedited,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.request_misc,
                                          "expedited",
                                          $$v
                                        )
                                      },
                                      expression: "request_misc.expedited",
                                    },
                                  }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      !_vm.isOneOffRequest &&
                      !_vm.isPartsRequest &&
                      !!_vm.isReplacementRequest &&
                      !_vm.replacementProductIsStockA
                        ? _c(
                            "el-col",
                            {
                              directives: [
                                {
                                  name: "acl",
                                  rawName: "v-acl.show",
                                  value: {
                                    permission: "select-stock-a",
                                    on: "CustomerRequest",
                                  },
                                  expression:
                                    "{ permission: 'select-stock-a', on: 'CustomerRequest' }",
                                  modifiers: { show: true },
                                },
                              ],
                              attrs: { span: 8 },
                            },
                            [
                              _c("label", [_vm._v("Stock A")]),
                              _vm._v(" "),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content:
                                      "Force Stock A not available - First setup is more than 30 days old",
                                    placement: "bottom",
                                    disabled:
                                      !!_vm.isReplacementRequest &&
                                      !_vm.firstSetupIsMoreThan30DaysOld,
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "el-input",
                                      staticStyle: { padding: "7px 0px" },
                                    },
                                    [
                                      _c("el-switch", {
                                        attrs: {
                                          disabled:
                                            !!_vm.isReplacementRequest &&
                                            !!_vm.firstSetupIsMoreThan30DaysOld,
                                        },
                                        model: {
                                          value: _vm.request_misc.stock_a,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.request_misc,
                                              "stock_a",
                                              $$v
                                            )
                                          },
                                          expression: "request_misc.stock_a",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "center-buttons" },
        [
          _c(
            "el-button",
            {
              attrs: { plain: "" },
              on: {
                click: function ($event) {
                  return _vm.back(1)
                },
              },
            },
            [_vm._v("\n      Back\n    ")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "info", plain: "" },
              on: {
                click: function ($event) {
                  return _vm.reset()
                },
              },
            },
            [_vm._v("\n      Reset\n    ")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary", disabled: !_vm.isValid, plain: "" },
              on: {
                click: function ($event) {
                  return _vm.next(3)
                },
              },
            },
            [_vm._v("\n      Next\n    ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }